import {
  getByDcUuidAndArticleUuid, getByDcUuidAndArticleUuidForWeb, modify, queryByArticles, querySettleQpcStr, save
} from '@/services/internal/article/ArticleBusiness';

export default {
  namespace: 'articleBusiness',

  state: {
    entity: '',
    articleBusiness: {},
    list: []
  },

  effects: {
    *add({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (callback) callback(response);
    },

    *modify({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (callback) callback(response);
    },

    *getByDcUuidAndArticleUuid({ payload, callback }, { call, put }) {
      const response = yield call(getByDcUuidAndArticleUuid, payload);
      // yield put({
      //   type: 'success',
      //   payload: response.data
      // })
      if (callback) callback(response);
    },
    *getByDcUuidAndArticleUuidForWeb({ payload, callback }, { call, put }) {
      const response = yield call(getByDcUuidAndArticleUuidForWeb, payload);
      yield put({
        type: 'success',
        payload: response.data
      })
      if (callback) callback(response);
    },
    *getByDcUuidAndArticleUuidNew({ payload, callback }, { call, put }) {
      const response = yield call(getByDcUuidAndArticleUuid, payload);
      yield put({
        type: 'successNew',
        payload: response.data
      })
      if (callback) callback(response);
    },
    *getByDcUuidAndArticleUuids({ payload, callback }, { call, put }) {
      const response = yield call(queryByArticles, payload);
      yield put({
        type: 'successQuery',
        payload: response.data
      })
      if (callback) callback(response);
    },
    *querySettleQpcStr({ payload, callback }, { call, put }) {
      const response = yield call(querySettleQpcStr, payload);
      if (callback) callback(response);
    },
  },

  reducers: {
    success(state, action) {
      return {
        ...state,
        entity: action.payload,
      };
    },
    successNew(state, action) {
      return {
        ...state,
        articleBusiness: action.payload,
      };
    },
    successQuery(state, action) {
      return {
        ...state,
        list: action.payload,
      };
    }
  }
}
